import { render, staticRenderFns } from "./OrgRetainedCasesByMonth.vue?vue&type=template&id=40ee2eed&scoped=true&"
import script from "./OrgRetainedCasesByMonth.vue?vue&type=script&lang=js&"
export * from "./OrgRetainedCasesByMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ee2eed",
  null
  
)

export default component.exports